import type React from 'react';

import type { RouteComponentProps } from '@xing-com/crate-core-router';
import { redirectTo, useParams } from '@xing-com/crate-core-router';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { XingletLoader } from '@xing-com/crate-xinglet';

const LETTER_OR_MISC_REGEX = /^misc$|^[a-zA-Z]{1}$/;
const USER_BAG_REGEX = /[A-Za-z]+-[A-Za-z]+(-p[0-9])?/;

export const RouteHandlerCity: React.FC<RouteComponentProps> = () => {
  const { citySlugOrLetter } = useParams();
  const { isLoggedOut } = useLoginState();

  if (!isLoggedOut) return redirectTo('/search/members');

  const isLetterMatch = citySlugOrLetter.match(LETTER_OR_MISC_REGEX);
  const isNameMatch = citySlugOrLetter.match(USER_BAG_REGEX);
  const isLetter = isLetterMatch ? isLetterMatch[0].toLowerCase() : null;
  const isName = isNameMatch ? isNameMatch[0].toLowerCase() : null;

  return isLetter ? (
    <XingletLoader name="@xing-com/crate-people-directory-letter-page-by-city" />
  ) : isName ? (
    <XingletLoader name="@xing-com/crate-people-directory-user-bag-page-by-city" />
  ) : (
    <XingletLoader
      name="@xing-com/crate-communication-error-pages"
      errorStatusCode={404}
      errorType="NotFound"
    />
  );
};
